import React, { useState } from 'react'
import styled from 'styled-components'
import Colors from '../assets/styles/Colors'
import CheckmarkIcon from '../assets/icons/JSX/CheckmarkIcon'
import Responsive from '../assets/config/Responsive'

const PoliciesCheckbox: React.FC<{
  id: string
  label?: string
  className?: string
  onChange: any
  onClick?: any
  style?: React.CSSProperties
  defaultChecked?: boolean
  disabled?: boolean
  checked?: boolean
  notChecke?: boolean
}> = ({
  id,
  label,
  className,
  onChange,
  onClick,
  style,
  defaultChecked = false,
  disabled = false,
  checked,
  notChecke = false,
}) => {
  //
  const [checkedStatus, setCheckedStatus] = useState<boolean>(defaultChecked)
  //
  return (
    <Wrapper style={style} className={className}>
      <Input
        onClick={onClick}
        style={{ opacity: disabled ? '0.6' : 'unset' }}
        disabled={disabled}
        defaultChecked={defaultChecked}
        checked={checked}
        type="checkbox"
        id={`field-${id}`}
        name={`field-${id}`}
        onChange={(event) =>
          notChecke ? null : [onChange(event.target.checked), setCheckedStatus(event.target.checked)]
        }
      />
      {checkedStatus === true ? (
        <Marker>
          <CheckmarkIcon />
        </Marker>
      ) : null}
      {/* <Label htmlFor={`field-${id}`}>{label}</Label> */}
    </Wrapper>
  )
}
//
//
const Marker = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 3px;
  background-color: ${Colors.primaryRed};
  position: absolute;
  /* top: 0; */
  left: 0;
  user-select: none;
  pointer-events: none;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px;
  /* inner icon svg */
  svg {
    width: 13px;
    color: ${Colors.white};
  }
  ${Responsive.laptop} {
    width: 18px;
    height: 18px;
  }
  ${Responsive.mobile} {
    padding-left: 5px;
  }
  ${Responsive.tablet} {
    padding-left: 5px;
  }
`
// const Label = styled.label`
//   font-size: 14px;
//   line-height: 16px;
//   color: ${Colors.rollingStone};
//   padding-left: 16px;
//   cursor: pointer;
// `
const Input = styled.input`
  width: 24px;
  height: 24px;
  border-radius: 3px;
  border-color: transparent;
  outline: none;
  padding: 0px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;

  /* after */
  &::after {
    content: '';
    display: block;
    border: 1px solid ${Colors.rollingStone};
    width: 24px;
    height: 24px;
    border-radius: 3px;
    background-color: ${Colors.white};
  }

  /* checked status styles */
  &:checked + label {
    color: ${Colors.primaryBlack};
  }
  ${Responsive.laptop} {
    width: 18px;
    height: 18px;
    &::after {
      width: 18px;
      height: 18px;
    }
  }
`
const Wrapper = styled.div`
  user-select: none;
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px;
`

export default PoliciesCheckbox
